import { PRIORITY_META } from '../../../entities/supportRequests/model/constants';
import type { RequestPriority } from '../../../entities/supportRequests/model/types';
import { cx } from '../../../utils/cx';
import styles from './PriorityTag.module.scss';

export interface PriorityTagProps {
    priority: RequestPriority;
    /** В карточке запроса подпись развёрнутая: «Приоритет: высокий». */
    withLabel?: boolean;
}

export function PriorityTag({ priority, withLabel = false }: PriorityTagProps) {
    const label = PRIORITY_META[priority].label;
    return (
        <span className={cx(styles.tag, styles[priority])}>
            {withLabel ? 'Приоритет: ' + label.toLowerCase() : label}
        </span>
    );
}
